import gql from 'graphql-tag'

export const BUSINESS_SUBSCRIPTION_CHECKOUT_MUTATION = gql`
  mutation BusinessSubscriptionCheckout($input: BusinessSubscriptionCheckoutInput!) {
    businessSubscriptionCheckout(input: $input) {
      checkoutUrl
      sessionId
      organization {
        id
        name
      }
      errors {
        attribute
        message
      }
    }
  }
`

export type BusinessSubscriptionCheckoutInput = {
  organizationId: string
  plan: 'monthly' | 'yearly'
  successUrl: string
  cancelUrl: string
}

export type BusinessSubscriptionCheckoutResponse = {
  businessSubscriptionCheckout: {
    checkoutUrl: string | null
    sessionId: string | null
    organization: {
      id: string
      name: string
    } | null
    errors: Array<{
      attribute: string | null
      message: string
    }> | null
  }
}
